export default "__VITE_ASSET__BUjyoE8X__"